export const EDIT_ADDRESS_MESSAGE =
  'Para alterar seu endereço cadastre o novo abaixo';
export const CREATE_ADDRESS_SUCCESS = 'Novo endereço criado com sucesso';
export const CREATE_ADDRESS_FAIL = 'Houve uma falha ao criar um novo endereço';
export const EDIT_ADDRESS_SUCCESS = 'Endereço atualizado com sucesso';
export const EDIT_ADDRESS_FAIL =
  'Houve uma falha ao atualizar o endereço desejado';
export const SELECT_ORDER_ADDRESS =
  'Selecione o endereço para entrega desejado para o pedido';
